// import React from 'react';
// import { Link, useParams } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import { useTranslation } from 'react-i18next';

// import Alert from 'reactstrap/lib/Alert';

// import { receiveProducts, receiveTickets } from '@ttstr/actions';
// import { Container, LoadingSpinner, Masonry, useIntl } from '@ttstr/components';
// import { AppState } from '@ttstr/reducers';
// import { useActions, useShallowEqualSelector } from '@ttstr/utils';
// import { Article } from '@ttstr/api';
// import FilteredMasonry from './FilteredMasonry';

// // wird nicht mehr gebraucht: Header soll ganz raus
// // import MerchstandImages from './assets/images/MerchstandImages';

// interface RouteParams {
//   readonly id: string;
// }

// type Props = {
//   /**
//    * productFilter can be used if you want a Route to a dedicated page for special merch/products.
//    *
//    * Example:
//    * You want a page only with merch that has the tag id 1234.
//    * The function for productFilter would then be
//    *  p => p.tag_ids.includes(1234)
//    *
//    * Then create a route in App.tsx with
//    * <Route exact path="/specialmerch" render={()=> <ProductListing productFilter={p => p.tag_ids.includes(1234)} />} />
//    */
//   productFilter?: (p: Article) => any;
// };

// const Home: React.FC<Props> = ({ productFilter = (p) => p }) => {
//   const { t } = useTranslation();
//   const params = useParams<RouteParams>();
//   const { products, loadingProducts, tickets, loadingTickets } = useShallowEqualSelector(mapStateToProps);
//   const { receiveProducts, receiveTickets } = useActions(mapDispatchToProps);
//   const { language } = useIntl();

//   if (!productFilter && params?.id) {
//     productFilter = (p) => p.category_ids.includes(Number(params.id));
//   }

//   React.useEffect(() => {
//     receiveProducts();
//     receiveTickets();
//   }, [language]);

//   return (
//     <article className="mb-5">
//       <Helmet>
//         <title>{t(`PRODUCTS.TITLE`)}</title>
//         <body className="landing-page" />
//       </Helmet>

//       {/* <div className="list-page-highlights">
//           <div className="container list-page">
//             {loadingProducts || loadingTickets ? ( // if loading
//               <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
//             ) : products.length === 0 ? ( // if no products
//               <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
//             ) : (
//               // else show products
//               <FilteredMasonry
//                 id="product-listing"
//                 products={products.filter(productFilter)}
//                 filters="off"
//                 dontUpdateQueryStrings
//                 tagId={6952}
//                 showSubtitle
//                 columnClassName="col-12 col-md-6 col-lg-6"
//                 // itemClassName="random-rotation-object"
//                 // itemImageClassName="scribble-hover-overlay-object"
//               />
//             )}
//           </div>
//         </div> */}

//       <Container className="list-page-products">
//         {/* <div className="text-center">
//           <img src={require('./assets/images/header.jpg')} alt="" className="img-fluid w-100 my-5" />
//         </div> */}

//         {/* <h1 className="superhead mb-0">PREORDER NOW</h1> */}
//         {loadingProducts || loadingTickets ? ( // if loading
//           <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
//         ) : products.length === 0 ? ( // if no products
//           <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
//         ) : (
//           // else show products
//           <FilteredMasonry
//             id="product-listing"
//             products={products.filter(productFilter)}
//             filters="off"
//             dontUpdateQueryStrings
//             tagId={8224}
//             showSubtitle
//             showFormerPrice
//             columnClassName="col-12 col-md-4 col-lg-4"
//             // itemClassName="random-rotation-object"
//             // itemImageClassName="scribble-hover-overlay-object"
//           />
//         )}
//       </Container>

//       <Container className="ticket-listing">
//         <h1 className="superhead my-5">TICKETS</h1>
//         {loadingProducts ? ( // if loading
//           <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
//         ) : products.length === 0 ? ( // if no products
//           <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
//         ) : (
//           // else show products
//           <Masonry
//             id="ticket-listing"
//             products={tickets}
//             columnClassName="col-12"
//             filters="off"
//             type="list"
//             showSubtitle
//             showCity
//             showLocation
//           />
//         )}
//       </Container>
//     </article>
//   );
// };

// const mapStateToProps = (state: AppState) => {
//   const { products } = state.Products;
//   const loadingProducts = state.Products.loading;
//   const { tickets } = state.Tickets;
//   const loadingTickets = state.Tickets.loading;
//   return {
//     products,
//     loadingProducts,
//     tickets,
//     loadingTickets,
//   };
// };

// const mapDispatchToProps = {
//   receiveProducts,
//   receiveTickets,
// };

// export default React.memo(Home);

// NEU
import React from 'react';
import { Helmet } from 'react-helmet';

import header1 from './assets/images/header_home.jpg';
import header2 from './assets/images/header_home1.jpg';
import header3 from './assets/images/header_home2.jpg';
import header4 from './assets/images/header_home3.jpg';
import header5 from './assets/images/header_home4.jpg';
import header6 from './assets/images/header_home5.jpg';
import header7 from './assets/images/header_home6.jpg';
import header8 from './assets/images/header_home7.jpg';

const Home: React.FC = () => {
  const [randomImage, setRandomImage] = React.useState<string | null>(null);

  React.useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    const desktopImages = [header1, header2, header3, header8];
    const mobileImages = [header4, header5, header6, header7, header3, header8];

    const selectedArray = isMobile ? mobileImages : desktopImages;

    const random = selectedArray[Math.floor(Math.random() * selectedArray.length)];

    setRandomImage(random);
  }, []);

  if (!randomImage) return null;

  return (
    <a
      href="https://shop.mosesyoofeetrio.com/products"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'block',
        width: '100vw',
        height: '100vh',
      }}
    >
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          backgroundImage: `url(${randomImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          width: '100vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          zIndex: 9999,
          cursor: 'pointer',
        }}
      >
        <Helmet>
          <title>Home</title>
          <body className="landing-page" />
        </Helmet>

        <img
          src={require('./assets/images/MYT_logo_orange.png')}
          alt="MYT Logo"
          style={{
            width: 'clamp(180px, 60vw, 500px)',
            height: 'auto',
          }}
        />
      </div>
    </a>
  );
};

export default React.memo(Home);
